var __TEMP__ = require('./_getNative.js');var getNative = __REQUIRE_DEFAULT__(__TEMP__);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = nativeCreate;
